import HolidayService from "../provider/Holiday/HolidayService";
import { SUCCESS, ERROR, WARNING } from "../common/Util";
import Util from "../common/Util";
import { CHANGE_APP_PROPS, CHANGE_HOLIDAY_PROPS } from "./ActionConstants";
import _ from "lodash";

export function actionGetHolidaysListFilters(name, date, page, size) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetHolidaysListFilters(name, date).then(response => {
			dispatch({
				type: CHANGE_HOLIDAY_PROPS,
				props: {
					holidaysList: response
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetHolidaysListFilters(name, date) {
	let response = await HolidayService.getHolidaysListFilters(name, date);
	return response;
}

export function actionGetHolidaysList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetHolidayList(searchText, offset, limit).then(response => {
			dispatch({
				type: CHANGE_HOLIDAY_PROPS,
				props: {
					holidaysList: response ? response : [],
					total: !_.isEmpty(response) ? response[0].cantidad : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetHolidayList(searchText, offset, limit) {
	try {
		//TODO
		let response = await HolidayService.getHolidayList(
			searchText,
			offset,
			limit
		);
		//START DATOS DE PRUEBA
		// let response=loadList(searchText, offset, limit);
		//END DTOS DE PRUEBA
		return response;
	} catch (error) {
		return error;
	}
}

export function actionCreateHoliday(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		values = formatObjectToJSON(values);
		asyncCreateHoliday(values)
			.then(response => {
				//TODO
				if (response.code)
					if (response.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				else callback(SUCCESS);
			})
			.catch(error => {
				//TODO
				console.log("error", error);
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

function formatObjectToJSON(values) {
	if (values.from_date) {
		values.from_date = Util.formatDateTimeToISODate(
			values.from_date,
			values.from_time
		);
	}
	if (values.to_date) {
		values.to_date = Util.formatDateTimeToISODate(
			values.to_date,
			values.to_time
		);
	}
	if (values.holiday_type) {
		values.holiday_type = { id: values.holiday_type };
	}
	delete values.from_time;
	delete values.to_time;
	return values;
}

async function asyncCreateHoliday(values) {
	//TODO
	let response = await HolidayService.setHoliday(values);
	return response;
	// let newObj = {"_id":"fc247e435e19e4b1bbdce0b5d4f2dc7c","_source":values};
	// listPrueba.unshift(newObj);
	// return values;
}

export function actionUpdateHoliday(holidayId, values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncUpdateHoliday(holidayId, values)
			.then(response => {
				if (response.code) {
					//TODO
					if (response.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				} else {
					let holidayList = store().holiday.holidaysList;
					const holidayIndex = holidayList.findIndex(e => {
						return e.id === response.id;
					});
					holidayList[holidayIndex] = response;
					dispatch({
						type: CHANGE_HOLIDAY_PROPS,
						props: {
							holiday: response,
							holidaysList: holidayList
						}
					});
					callback(SUCCESS);
				}
			})
			.catch(error => {
				error.then(errorVal => {
					//TODO
					if (errorVal.code && errorVal.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
					callback(ERROR);
				});
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateHoliday(holidayId, values) {
	//TODO
	let response = await HolidayService.updateHoliday(holidayId, values);
	return response;
	// for(let index in listPrueba){
	// 	if(listPrueba[index]._id == holidayId){
	// 		listPrueba[index]._source=values;
	// 	}
	// }
	// return values;
}

export function actionDeleteHoliday(holidayId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteHoliday(holidayId)
			.then(response => {
				//TODO
				if (response.code && response.code === 41215203) {
					callback(WARNING);
				} else {
					callback(SUCCESS);
				}
			})
			.catch(error => {
				callback(ERROR);
			});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncDeleteHoliday(holidayId) {
	//TODO
	let response = await HolidayService.deleteHoliday(holidayId);
	return response;
	// for(let index in listPrueba){
	// 	if(listPrueba[index]._id == holidayId){
	// 		listPrueba.splice(index,1);
	// 	}
	// }
	// return holidayId;
}

export function actionChangeHolidayProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_HOLIDAY_PROPS,
			props: props
		});
	};
}

export function actionCopyHoliday(holidayId, values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncCopyHoliday(holidayId, values)
			.then(response => {
				//TODO
				if (response.code)
					if (response.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				else callback(SUCCESS);
			})
			.catch(error => {
				//TODO
				error.then(errorVal => {
					if (errorVal.code && errorVal.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				});
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncCopyHoliday(holidayId, values) {
	//TODO
	let response = await HolidayService.copyHoliday(holidayId, values);
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/HolidayActions.js